import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  Chip,
} from '@mui/material';
import {
  LanguageOutlined,
  InfoOutlined,
} from '@mui/icons-material';
import { makeStyles } from '@mui/styles';
import Button from 'components/CustomButtons/Button.js';

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    minWidth: 400,
  },
  languageChip: {
    margin: theme.spacing(0.5),
  },
  infoSection: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: '#f5f5f5',
    borderRadius: '4px',
  },
  iconTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  messageText: {
    marginBottom: theme.spacing(2),
  },
}));

export default function SupportedLanguagesMigrationModal({
  open,
  onMigrate,
  languages = [],
  loading = false,
}) {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={undefined}
      aria-labelledby='migration-dialog-title'
      maxWidth='sm'
      fullWidth
      disableEscapeKeyDown
    >
      <DialogTitle id='migration-dialog-title'>
        Supported Languages Update
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant='body1' className={classes.messageText}>
              We've improved how supported languages are managed in the portal. 
              Your language settings are now part of your tenant configuration 
              for better organization.
            </Typography>
          </Grid>

          {languages.length > 0 && (
            <>
              <Grid item xs={12}>
                <Typography variant='subtitle2' gutterBottom>
                  Your current supported languages:
                </Typography>
                <div>
                  {languages.map((lang, index) => (
                    <Chip
                      key={index}
                      label={lang}
                      size='small'
                      className={classes.languageChip}
                      color='primary'
                      variant='outlined'
                    />
                  ))}
                </div>
              </Grid>
            </>
          )}

          <Grid item xs={12}>
            <div className={classes.infoSection}>
              <Typography variant='body2' color='textSecondary'>
                <strong>What happens next?</strong>
                <br />
                • Your language settings will be preserved
                <br />
                • No data will be deleted
                <br />
                • This is a one-time update
                <br />
                • You can continue working normally
              </Typography>
            </div>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button
          color='rose'
          onClick={onMigrate}
          disabled={loading}
        >
          {loading ? 'Updating...' : 'Update Now'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
